import React from 'react';
import { services } from '../mockData';
import { CheckCircle } from 'lucide-react';

const Services = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="bg-gray-800 py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">Our Services</h1>
        </div>
      </div>

      {/* Services Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="text-yellow-500 font-semibold text-sm uppercase tracking-wider">We Are Specialists In</span>
            <h2 className="text-4xl font-bold text-gray-800 mt-2">What We Do</h2>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
              We are specialists in engineering design, industrial instrumentation, battery refurbishment, PCB development, and precision manufacturing.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-gray-50 p-8 hover:shadow-xl transition-all duration-300 group"
              >
                <div className="mb-6 flex justify-center">
                  <img src={service.icon} alt={service.title} className="h-20 w-20" />
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center group-hover:text-yellow-500 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 text-center">{service.description}</p>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2 text-gray-700">
                    <CheckCircle size={20} className="text-yellow-500" />
                    <span>Professional Team</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <CheckCircle size={20} className="text-yellow-500" />
                    <span>Quality Materials</span>
                  </li>
                  <li className="flex items-center gap-2 text-gray-700">
                    <CheckCircle size={20} className="text-yellow-500" />
                    <span>Timely Delivery</span>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;